function HomeStatsSection({ portfolioStats }) {
  return (
    <section className="mx-auto grid w-[min(1120px,calc(100%-40px))] gap-4 py-2 md:grid-cols-3">
      {portfolioStats.map((stat) => (
        <article
          className="rounded-[24px] border border-[#18322812] bg-[rgba(255,255,255,0.52)] px-6 py-5 shadow-[0_12px_28px_rgba(24,50,40,0.05)]"
          key={stat.label}
        >
          <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">{stat.label}</p>
          <p className="m-0 font-serif text-4xl font-semibold text-[#163127]">{stat.value}</p>
        </article>
      ))}
    </section>
  );
}

export default HomeStatsSection;